import { BaseAPI } from './base.api';
import { Acompanhamento } from '@/models/acompanhamento';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
export class AcompanhamentoAPI extends BaseAPI<Acompanhamento> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_app/v1/accompaniments`;
  }

  public list(params: any): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) });
  }
}
